module.exports = __webpack_public_path__ + "img/JL.1d8e058c.jpg";